<template>
  <div class="ui-nio-button"
       :class="[size, round ? 'round' : '', type, disabled ? 'disabled' : '']"
       @click="$emit('click')">
    <slot></slot>
  </div>
</template>

<script>
/*
 * http://lanhu.nioint.com/web/#/item/project/board?from=nav&pid=1fa460ad-be62-4eda-a7e7-1b0d5fe2aec3
 */
export default {
  name: 'NioButton',
  props: {
    text: {
      type: String
    },
    round: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'btn_solid_l'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/standard";

.ui-nio-button {
  height: 45px;
  min-width: 80px;
  padding: 0 sizeTrans($space_15);
  line-height: 45px;
  text-align: center;
  cursor: pointer;

  &.round {
    border-radius: 45px;
  }

  &.btn_solid_l {
    @include btn_solid_l();
  }

  &.btn_outline_l {
    @include btn_outline_l();
  }

  &.btn_solid_l_bg {
    @include btn_solid_l_bg();
  }

  &.btn_outline_l_bg {
    @include btn_outline_l_bg();
  }

  &.disabled {
    pointer-events: none;
    @include btn_solid_l();
  }
}
</style>